import ContentItemBase from '../ContentItemBase'

export default {
  extends: ContentItemBase,
  beforeCreate: function () {
    this.navEventID = 'PortfolioMenu'
  }
}
